import React from 'react';

//Hooks
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

//Actions
import * as actions from '../../../store/actions/companies';

//Components
import { Container } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import Shop from '../../../components/Shop/Shop';

import { ROUTER_URL } from '../../../const/ROUTER_URL';

//Styles
import Styles from './Shops.module.scss';

const Shops = () => {
    const shops = useSelector(state => state.companies.shops);
    const dispatch = useDispatch();

    const history = useHistory();

    useEffect(() => {
        if (shops) {
            return;
        }

        dispatch(actions.getShopList())
    }, [dispatch, shops]);

    if (!shops) {
        return (
            <div className={Styles.centeredContainer}>
                <Loader
                    type="TailSpin"
                    color="#000"
                    height={48}
                    width={48}
                />
            </div>
        )
    }

    if (shops.length === 1) {
        return <Redirect to={ROUTER_URL.SHOPS_ID({ shopId: shops[0].id })}/>
    }

    return (
        <Container className={'px-0 overflow-auto flex-grow-1'}>
            <div className={Styles.container}>
                {shops.map((shop) => (
                    <Shop
                        key={`shop-${shop.id}`}
                        shop={shop}
                        onClick={() => {
                            history.push(ROUTER_URL.SHOPS_ID({ shopId: shop.id }));
                        }}
                    />
                ))}
            </div>
        </Container>
    );
};

export default Shops
